import apiClient from '../middleware/apiClient';
import { SSM_USER } from '../helpers/apis';
import { COTTON_SSM_USER } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';


function dispatchGetUser(isCottonSession = false, now = false) {
  const baseEndpoint = isCottonSession ? COTTON_SSM_USER : SSM_USER;
  const endpoint = now ? `${baseEndpoint}?now=true` : baseEndpoint;
  return {
    type: GET_USER,
    payload: apiClient.fetch(endpoint),
  };
}

export function dispatchGetUserSuccess(user) {
  return {
    type: GET_USER_SUCCESS,
    payload: user,
  };
}

export function dispatchGetUserFailure(error) {
  return {
    type: GET_USER_FAILURE,
    payload: error,
  };
}

export const getUser = now => async (dispatch, getState) => {
  const {
    user: { cached } = {},
  } = getState();
  if (cached) {
    return null;
  }

  try {
    const isCottonSession = getCottonSession();
    const response = await dispatch(dispatchGetUser(isCottonSession, now)).payload;
    return dispatch(dispatchGetUserSuccess(response));
  } catch (error) {
    dispatch(dispatchGetUserFailure(error));
    throw error;
  }
};
